import { useStateContext } from "../../contexts/ContextProvider";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import moment from "moment";
import { useEffect, useState } from "react";

import Select from "react-select";

const ReportsFilterModal = ({
  user,
  details,
  setDetails,
  tabIndex,
  checked,
  handleCheckedChange,
  handleFilter,
  clearFilter,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  checked2,
  handleCheckedChange2,
  selectedReportType,
  year,
  setYear,
}) => {
  const { filterBy, locations, employees } = useStateContext();

  const [empOption, setEmpOption] = useState({});

  const [date, setDate] = useState(new Date());

  // console.log("checked2", checked2);

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);

  const handleSelectChange = (e, type) => {
    // console.log(e.value);
    if (type === "location") {
      setDetails((prev) => ({
        ...prev,
        location: e.value,
      }));
    } else {
      setDetails((prev) => ({
        ...prev,
        [type]: e.value,
      }));
    }
  };

  const handleChangeFromDate = (e) => {
    setFromDate(e.value);
    setDetails((prev) => ({
      ...prev,
      fromDate: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedFromDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
  };

  const handleChangeToDate = (e) => {
    setToDate(e.value);
    setDetails((prev) => ({
      ...prev,
      toDate: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedToDate: moment(new Date(e.value)).format("D MMM YYYY"),
    }));
  };

  const handleDateChange = (e) => {
    // console.log(e.value);
    setDate(e.value);
    const year = moment(new Date(e.value)).format("YYYY");
    setYear(year);
  };

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>

            {selectedReportType.value === "2" ||
            tabIndex === 1 ||
            tabIndex === 2 ? (
              <>
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    From Date
                  </label>
                  <Calendar
                    value={fromDate}
                    onChange={handleChangeFromDate}
                    view="date"
                    dateFormat="dd, MM, yy"
                    style={{ width: "100%", height: "45px" }}
                    showIcon
                    selectOtherMonths
                  />
                </div>
                <div className="mb-3 calendar-relative">
                  <label htmlFor="leaveType" className="form-label">
                    To Date
                  </label>
                  <Calendar
                    value={toDate}
                    onChange={handleChangeToDate}
                    view="date"
                    dateFormat="dd, MM, yy"
                    style={{ width: "100%", height: "45px" }}
                    showIcon
                    selectOtherMonths
                  />
                </div>
              </>
            ) : null}

            {tabIndex === 2 ? (
              <>
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Employee Name
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                          ? "rgba(177, 206, 251, 1)"
                          : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                          ? "rgba(78, 70, 94, 1)"
                          : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={empOption}
                    onChange={(e) => {
                      handleSelectChange(e, "empId");
                    }}
                    value={
                      Array.isArray(empOption)
                        ? empOption.filter(
                            (option) => option.value === details.empId
                          )
                        : null
                    }
                  />
                </div>
              </>
            ) : null}

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Location
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                      ? "rgba(177, 206, 251, 1)"
                      : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                      ? "rgba(78, 70, 94, 1)"
                      : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={locations}
                onChange={(e) => {
                  handleSelectChange(e, "location");
                }}
                value={
                  Array.isArray(locations)
                    ? locations.filter(
                        (option) => option.value === details.location
                      )
                    : null
                }
              />
            </div>

            {tabIndex === 0 ? (
              <>
                {selectedReportType.value === "1" && (
                  <>
                    <div className="mb-3">
                      <Calendar
                        value={date}
                        onChange={handleDateChange}
                        view="year"
                        dateFormat="yy"
                        style={{ width: "100%" }}
                        showIcon
                        selectOtherMonths
                      />
                    </div>

                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Quarter
                      </label>
                      <div className="statusFilter-flex visible">
                        <div className="sort-flex">
                          <span className="status-filter">1st Quarter</span>
                          <label className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={checked.includes("Q1")}
                              onChange={handleCheckedChange("Q1")}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className="sort-flex">
                          <span className="status-filter">2nd Quarter</span>
                          <label className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={checked.includes("Q2")}
                              onChange={handleCheckedChange("Q2")}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className="sort-flex">
                          <span className="status-filter">3rd Quarter</span>
                          <label className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={checked.includes("Q3")}
                              onChange={handleCheckedChange("Q3")}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                        <div className="sort-flex">
                          <span className="status-filter">4th Quarter</span>
                          <label className="checkbox-container">
                            <input
                              type="checkbox"
                              checked={checked.includes("Q4")}
                              onChange={handleCheckedChange("Q4")}
                            />
                            <span className="checkmark"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Columns
                  </label>
                  <div className="statusFilter-flex visible">
                    <div className="sort-flex">
                      <span className="status-filter">Paid</span>
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={checked2[0] === "Paid"}
                          onChange={handleCheckedChange2("Paid", 0)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="sort-flex">
                      <span className="status-filter">Goodwill</span>
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={checked2[1] === "Goodwill"}
                          onChange={handleCheckedChange2("Goodwill", 1)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="sort-flex">
                      <span className="status-filter">Unpaid</span>
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={checked2[2] === "Unpaid"}
                          onChange={handleCheckedChange2("Unpaid", 2)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="sort-flex">
                      <span className="status-filter">LOP/Late Mark</span>
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={checked2[3] === "LOP/Late Mark"}
                          onChange={handleCheckedChange2("LOP/Late Mark", 3)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>

                    <div className="sort-flex">
                      <span className="status-filter">Total Absent Days</span>
                      <label className="checkbox-container">
                        <input
                          type="checkbox"
                          checked={checked2[4] === "Total Absent Days"}
                          onChange={handleCheckedChange2(
                            "Total Absent Days",
                            4
                          )}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportsFilterModal;
